<div class="col-md-12 mt-4" style="padding: 0;">

  @for (qualification of educationDetails | keyvalue; track qualification) {
    <div>
      @if (qualification.value !== null) {
        <div class="row">
          <div class="col-xl-8 col-md-12 col-xs-12">
            <h4 class="mb-4">
              {{qualification.key | caseSplit}}
            </h4>
            <div class="form-group">
              <label for="chooseCourseProvider">Course provider</label>
              <div class="form-control readonly">
                <mat-select [(ngModel)]="qualification.value.qualificationId" placeholder="Choose a course provider"
                  [name]="qualification.key + 'Selection'" required [disabled]="true">
                  @for (course of getCourseTypes(qualification.key); track course) {
                    <mat-option
                      [value]="course.id">
                      {{ course.courseName }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-xl-offset-2 col-md-12 col-xs-12 ">
            <div class="form-group">
              <app-daterange [readonly]="true" [fromDate]="qualification.value.dateCommenced"
              [toDate]="qualification.value.dateAwarded"></app-daterange>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>